import { ReactElement } from "react";

export default function DealmakerIntro(): ReactElement {
  return (
    <div className="dealmaker-intro">
      <p>
        The WSG Dealmaker Program allows member firms and professionals the opportunity to make deals and collaborate across a multidisciplinary platform for clients. Together these advantages help members to better counsel clients, differentiate their service offerings and generate future business opportunities.
      </p>
      <p>
        To submit a deal on behalf of your firm, <a href="/manage_dealmaker.asp">click here</a> and follow the process or contact <a href="mailto:info@worldservicesgroup.com">info@worldservicesgroup.com</a>
      </p>
    </div>
  );
}
